<template>
  <v-row class="mb-4">
    <v-col cols="12" class="pa-3 d-flex flex-column pa-0">
      <div class="d-flex align-center">
        <v-btn
          v-if="showBack"
          icon
          class="mr-2"
          :title="backLabel"
          aria-label="Go back"
          @click="handleBack"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h1 class="text-h5 font-weight-medium mb-0">{{ title }}</h1>
        <v-spacer></v-spacer>
        <slot name="actions"></slot>
      </div>
      <div class="subtitle" v-if="$slots.subtitle">
        <slot name="subtitle"></slot>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    showBack: {
      type: Boolean,
      default: false
    },
    backTo: {
      type: String,
      default: ''
    },
    backLabel: {
      type: String,
      default: 'Go back'
    }
  },
  methods: {
    handleBack() {
      if (this.backTo) {
        this.$router.push(this.backTo).catch(() => {})
        return
      }

      if (window.history.length > 1) {
        this.$router.back()
        return
      }

      this.$router.push('/').catch(() => {})
    }
  }
}
</script>

<style scoped>
.actions-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
}
</style>
